import { Navigate } from 'react-router-dom'
// import { BindState } from '@/services/wx'
// import style from './index.module.less'

const HomePage = () => {
  return <Navigate to="/chat" replace={true}></Navigate>
}
export default HomePage
